<template>
	<drawer
			:title="titleDrawer"
			@updateClose="onClose"
			@updateSave="onSave"
	>

		<item-info-row
				icon-id="calendar0"
				text="Date:"
				:value="dateMod"
				margin="0 0 10px 0"
		></item-info-row>
		<item-info-row
				icon-id="TimeCheck"
				text="Total work time:"
				:value="total_time"
				margin="0 0 10px 0"
		></item-info-row>

		<div class="inputsGroup">
			<div class="infoTitle">Schedule</div>
			<div class="inputsWrap">
				<field
						margin="0"
						label="In"
						placeholder="HH:MM"
						:setInputValue="schedule_in"
						@updateInput="onInput($event, 'schedule_in')"
						is-required
						is-input
						is-time-field
						:class-error="getError('schedule_in')"
				/>
				<field
						margin="0"
						label="Out"
						placeholder="HH:MM"
						:setInputValue="schedule_out"
						@updateInput="onInput($event, 'schedule_out')"
						is-required
						is-input
						is-time-field
						:class-error="getError('schedule_out')"
				/>
			</div>
		</div>

		<item-info-row
				v-if="totalScheduleMod"
				icon-id="icon-magic"
				text="Mod total schedule time:"
				:value="totalScheduleMod"
				margin="0 0 10px 0"
		></item-info-row>

		<div class="inputsGroup">
			<div class="infoTitle">Work time</div>
			<div class="inputsWrap">

				<field
						margin="0"
						label="In"
						placeholder="HH:MM"
						:setInputValue="check_in"
						@updateInput="onInput($event, 'check_in')"
						is-required
						is-input
						is-time-field
				/>
				<field
						margin="0"
						label="Out"
						placeholder="HH:MM"
						:setInputValue="check_out"
						@updateInput="onInput($event, 'check_out')"
						is-required
						is-input
						is-time-field
				/>
			</div>
		</div>

		<item-info-row
				v-if="totalTimeMod"
				icon-id="icon-magic"
				text="Mod total time:"
				:value="totalTimeMod"
				margin="0 0 10px 0"
		></item-info-row>

	</drawer>
</template>

<script>
import Drawer from "@/shared/Drawer/Drawer";
import { validationMixin } from "vuelidate";
// import { required } from "vuelidate/lib/validators";
import ItemInfoRow from "@/shared/ItemInfoRow/ItemInfoRow.vue";
import { bothOrEmpty } from "@/pages/UserProfile/Drawers/bothOrEmpty";

// import VueMask from 'v-mask';
// Vue.use(VueMask);

export default {
	name: "EditTime",
	mixins: [ validationMixin ],
	components: { ItemInfoRow, Drawer },

	props: {
		activeItem: Object,
	},
	validations() {
		const origIn = this.activeItem?.schedule_in || '';
		const origOut = this.activeItem?.schedule_out || '';

		return {
			// check_in: { required },
			// check_out: { required },
			schedule_in: {
				custom: () => bothOrEmpty(this.schedule_in, this.schedule_out, origIn, origOut)
			},
			schedule_out: {
				custom: () => bothOrEmpty(this.schedule_in, this.schedule_out, origIn, origOut)
			},
		};
	},

	data() {
		return {
			titleDrawer: 'Edit work time',
			mask: '##:##',

			check_in: '',
			check_out: '',
			schedule_in: '',
			schedule_out: '',
			schedule_out2: '',
			total_time: '',
			totalTimeMod: null,
			totalScheduleMod: null,
			date: null,
			dateMod: null,
		};
	},
	methods: {

		getError(key) {
			return this.$v[key]?.$error;
		},
		onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const { check_in, check_out, date, schedule_in, schedule_out, } = this.$data;
				this.$emit('updateSave', { check_in, check_out, start_time: schedule_in, end_time: schedule_out, date }, this.activeItem);
			} else {
				this.$store.dispatch('setAlert', { type: "error", message: "🕒 Please fill in both Schedule In and Schedule Out fields." });
			}
		},
		onClose() {
			this.$emit('updateClose');
		},
		onInput({ value }, key) {
			this[key] = value;

			if ((this.check_in && this.check_out) && (key === 'check_in' || key === 'check_out')) {
				this.totalTimeMod = this.calculateWorkedTime(this.check_in, this.check_out);
			}
			if ((this.schedule_in && this.schedule_out) && (key === 'schedule_in' || key === 'schedule_out')) {
				this.totalScheduleMod = this.calculateWorkedTime(this.schedule_in, this.schedule_out);
			}

		},
		onAutocomplete({ value }, key) {
			this[key] = value.id;
		},
		onCheckbox({ value }, key) {
			this[key] = value;
		},
		calculateWorkedTime(checkIn, checkOut) {
			const moment = require('moment'); // Убедитесь, что moment.js подключен

			const checkInTime = moment(checkIn, "HH:mm:ss");
			const checkOutTime = moment(checkOut, "HH:mm:ss");

			// Если время checkOut меньше времени checkIn, значит был переход через полночь
			if (checkOutTime.isBefore(checkInTime)) {
				checkOutTime.add(1, 'day');
			}

			const duration = moment.duration(checkOutTime.diff(checkInTime));

			const hours = String(duration.hours()).padStart(2, '0');
			const minutes = String(duration.minutes()).padStart(2, '0');
			// const seconds = String(duration.seconds()).padStart(2, '0');

			return `${ hours }:${ minutes }`;
		}
	},
	mounted() {
		if (this.activeItem) {
			const {
				check_in,
				check_out,
				date,
				// duty,
				// isDisabled,
				name,
				// remote,
				schedule_in,
				schedule_out,
				// sick,
				total_time,
				// vacation,

			} = this.activeItem;

			this.name = name;
			this.date = date;
			this.check_in = check_in.slice(0, 5);
			this.check_out = check_out.slice(0, 5);
			this.schedule_in = schedule_in;
			this.schedule_out = schedule_out;
			this.total_time = total_time;

			this.dateMod = `${ name }, ${ date }`;
		}
	}
};

</script>

<style scoped lang="scss">
.inputsGroup {
	display: flex;
	flex-direction: column;
	gap: 8px;
	margin-bottom: 14px;
	.infoTitle {
		font-weight: bold;
		color: #a3a3a3;
	}
	.inputsWrap {
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-gap: 10px;
	}
}

</style>
